import * as React from 'react';
import './link.scss';
import { trackSiteExpetise } from '../../Utils/Tracking';

let classNames = require('classnames');

const TrackExpertiseEvent = (tracking, label, url) => {
  if(tracking)
  {
    if( tracking == "expertise_site" || "pays_site")
    {
      trackSiteExpetise("clic_expertise_site","accueil","home",label,url)
    }

  
  }
}

function Link({ customClass, href, label, target = '_self', children, ariaLabel, tracking }) {

  return (
    <a className={classNames(['links', customClass])} href={href} target={target} aria-label={ariaLabel || ''} onClick={()=>TrackExpertiseEvent(tracking, children || label, href)}>{children || label}</a>
  );
}

export default Link;
